"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Checkbox_1 = __importDefault(require("../../Checkbox"));
var styles_1 = __importDefault(require("./styles"));
var Item = function (_a) {
    var isHidden = _a.isHidden, label = _a.label, onClick = _a.onClick, isSelected = _a.isSelected;
    if (isHidden)
        return null;
    return (react_1.default.createElement(styles_1.default, { className: "option " + (isSelected ? 'selected' : ''), onClick: onClick },
        react_1.default.createElement(Checkbox_1.default, { className: "checkbox", value: isSelected, onChange: null }),
        react_1.default.createElement("label", { className: "label" }, label)));
};
exports.default = Item;
//# sourceMappingURL=index.js.map